// relative
import { apiSlice } from '../../apiSlice';

export const occupancyApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['Occupancy'],
  endpoints: (builder) => ({
    getOccupancyEvents: builder.query({
      query: () => {
        return `/OccupancyCalendar?orderby=Start&top=10000`;
      },
      providesTags: ['Occupancy'],
    }),
    getOccupancyEventsBySubscriptionId: builder.query({
      query: (id) => {
        return `/OccupancyCalendar?orderby=Start&JobSubscriptionId=eq(${id})&top=10000`;
      },
      providesTags: ['Occupancy'],
    }),
    getOccupancyEventsByBuildingId: builder.query({
      query: (id) => {
        return `/OccupancyCalendar?orderby=Start&BuildingId=eq(${id})&top=10000`;
      },
      providesTags: ['Occupancy'],
    }),
    postOccupancyEvent: builder.mutation({
      query: (data) => ({
        url: '/OccupancyCalendar',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Occupancy'],
    }),
    deleteOccupancyEvent: builder.mutation({
      query: (id) => ({
        url: `/OccupancyCalendar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Occupancy'],
    }),
    putOccupancyEvent: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/OccupancyCalendar/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Occupancy'],
    }),
  }),
});

export const {
  useGetOccupancyEventsQuery,
  useGetOccupancyEventsBySubscriptionIdQuery,
  useLazyGetOccupancyEventsBySubscriptionIdQuery,
  useGetOccupancyEventsByBuildingIdQuery,
  useLazyGetOccupancyEventsByBuildingIdQuery,
  usePostOccupancyEventMutation,
  useDeleteOccupancyEventMutation,
  usePutOccupancyEventMutation,
} = occupancyApiSlice;
